module.exports = __webpack_public_path__ + "linea-arrows-10.9b287297a8d930c35c32.eot";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-arrows-10.eot
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-arrows-10.eot
// module chunks = styles